<template lang="pug">
.main
  v-layout(style="height:100vh")
    v-container.my-auto.white.lighten-4.px-4(style="max-width: 500px;")
      template.text-center(v-if="email")
        div.align-center.justify-center.text-center.mb-0
          eva-icon.pt-1(name="email-outline" :fill="$vuetify.theme.themes[$theme].info500" width="40" height="40")
        h5.text-center.mt-1.mb-4.grey--text.text--darken-3 {{ $t('check_email') }}
        div.text-center
          h6.p2 {{ $t('confirmation_code_sent') }}
          h6.p2 {{ email }}.
          h6.p2 {{ $t('enter_code') }}
      template(v-if="phone")
        h5.text-center.my-4.grey--text.text--darken-3 {{ $t('check_phone') }}
        div.text-center
          h6.p2 {{ $t('tac_sent') }}
          h6.p2 {{ phone }}.
          h6.p2 {{ $t('enter_tac') }}
      div(outlined v-if="email")
        v-card.my-8.pa-4(flat outlined)
          v-card-text
            p.mb-4.label.basic600--text.text-uppercase {{ $t('confirmation_code') }} 
            v-text-field.code.grey--text.mb-4( dense solo flat background-color="basic200"   height="40" v-model="code" :autofocus="true" type="text"  outlined :disabled="disabled" hide-details)
              template(v-slot:label)
                .p1.basic600--text {{ $t('enter_code_title') }}
            .p2.primary400--text {{ $t('keep_window_open') }}
        div.text-center
          .c2.primary400--text {{ $t('check_received_email') }}
          .c2.primary400--text {{ $t('try_spam_folder') }} 
            span.c2.info500--text(@click="resend") {{ $t('resend') }}
          .c2.primary400--text.mt-4 {{ $t('having_trouble') }}
            a.c2.info500--text(href="https://yezzaio.typeform.com/to/nOLS7NLP" target="_blank") {{ $t('click_here') }}
      div(outlined v-if="phone")
        v-card.my-8.pa-4(flat outlined)
          v-card-text
            p.mb-1.label.basic600--text.text-uppercase {{ $t('otp_number') }}
            v-text-field.code.grey--text.mb-4(outlined dense solo flat background-color="basic200" height="40" v-model="code" :autofocus="true" type="text" :disabled="disabled")
              template(v-slot:label)
                    .p1.basic600--text {{ $t('enter_otp_number') }}
            .text-center
              h6.p2(style="color: #848484;") {{ $t('keep_this_open') }}
        div.text-center
          h6.c2(style="color: #848484;") {{ $t('did_not_received_sms') }}
          h6.c2(style="color: #848484;") {{ $t('wait_few_seconds') }}
          |
          span.info500--text(@click="resendOTP") {{ $t('resend') }}
          h6.c2.mt-4(style="color: #848484;") {{ $t('having_trouble') }}
          |
          a.c2.info500--text(href="https://yezzaio.typeform.com/to/nOLS7NLP" target="_blank") {{ $t('click_here') }} 
      
  </template>

<script>
import TopBar from '@/components/TopBar'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "Verify",
  components: { TopBar },
  props: ['email', 'phone', 'pushTo'],
  data: () => ({
    code: '',
    disabled: false
  }),
  watch: {
    code (val) {
      if (val.length >= 6) {
        this.submit()
      }
    }
  },
  computed: {
    ...mapGetters({
      lang: 'language/getLanguage'
    }),
  },
  mounted () {
    if (!this.email && !this.phone) {
      this.$router.push('/signin')
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    submit () {
      this.disabled = true
      if (this.email) {
        this.$axios.post('/users/check_verification_code/', { email: this.email, code: this.code  })
            .then(() => {
              const pushTo = { name: this.pushTo, params: { email: this.email, code: this.code }}
              this.$router.push(pushTo)
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.invalid_code')])
              this.$refs.code.focus()
            })
            .finally(() => {
              this.disabled = false
            })
      } else if (this.phone) {
        this.$axios.post('/users/check_otp/', { phone: this.phone, otp: this.code, generate_otp_verified_token: true })
            .then(resp => {
              const pushTo = { name: this.pushTo, params: { email: this.email, phone: this.phone, code: resp.data.otp_verified_token }}
              this.$router.push(pushTo)
            })
            .catch(() => {
              if (this.email) {
                this.showMessage(['error', this.$t('error_message.invalid_code')])
              } else if (this.phone) {
                this.showMessage(['error', this.$t('error_message.invalid_tac')])
              }
              this.$refs.code.focus()
            })
            .finally(() => {
              this.disabled = false
            })
      }
    },
    resend () {
      this.$axios.post('/users/send_verification_code/', { email: this.email, language: this.lang })
        .then(() => {
          this.showMessage(['info', this.$t('info_message.confirmation_code_sent_to', { text: this.email })])
        })
        .catch(() => {})
    },
    resendOTP () {
      this.$axios.post('/users/request_otp/', { phone: this.phone })
        .then(() => {
          this.showMessage(['info', this.$t('info_message.tac_sent_to', { text: this.phone })])
        })
        .catch(() => {})
    }
  }
}
</script>


<style lang="scss">
  .code input {
    font-size: 2rem;
    font-weight: 600;
    letter-spacing: .28em;
    text-align: center;
    padding: 0;
  }
</style>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "confirmation_code_sent" : "We’ve sent a confirmation code to",
    "enter_code":"Enter the code soon, as it will expire shortly.",
    "tac_sent":"We’ve sent a sms with TAC number to",
    "check_phone" : "Check your phone",
    "check_email" : "Check your email",
    "enter_tac":"Enter the TAC number soon, as it will expire shortly.",
    "confirmation_code":"Confirmation Code",
    "enter_code_title":"Enter Your Code",
    "keep_window_open":"Keep this open while you check your email inbox.",
    "check_received_email": "Did not receive an email?",
    "try_spam_folder":"Try the spam folder or",
    "having_trouble":"Still having trouble verifying?",
    "click_here" : "Click Here",
    "otp_number":"OTP Number",
    "enter_otp_number":"Enter Your OTP",
    "keep_this_open":"Keep this open while you check your phone for an SMS.",
    "did_not_received_sms":"Did not receive an SMS?",
    "wait_few_seconds": "Wait for a few minutes or "
  },
   "id": {
    "confirmation_code_sent" : "Kami telah mengirimkan kode konfirmasi ke",
    "enter_code":"Masukkan kode segera, karena akan segera kedaluwarsa.",
    "tac_sent":"Kami telah mengirim sms dengan nomor TAC ke",
    "check_phone" : "Periksa fon kamu",
    "check_email" : "Periksa email kamu",
    "enter_tac":"Masukkan nomor TAC segera, karena akan segera kedaluwarsa.",
    "confirmation_code":"Kode Konfirmasi",
    "enter_code_title":"Masukkan Kode kamu",
    "keep_window_open":"Biarkan ini tetap terbuka saat kamu memeriksa kotak masuk email kamu.",
    "check_received_email": "Tidak menerima email?",
    "try_spam_folder":"Coba folder spam atau",
    "have_trouble":"Masih mengalami masalah saat memverifikasi?",
    "click_here" : "Klik Disini",
    "otp_number":"Nomor OTP",
    "enter_otp_number":"Masukkan OTP kamu",
    "keep_this_open":"Biarkan ini terbuka saat kamu memeriksa ponsel kamu untuk SMS.",
    "did_not_received_sms":"Tidak menerima SMS?",
    "wait_few_seconds": "Tunggu beberapa menit atau "
  }
}
</i18n>